import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

// Modern analytics-product tab strip: thin bottom border, active tab gets a
// bold label + a colored underline indicator. Horizontally scrollable so it
// never wraps/overflows on narrow screens.
const ReportTabs = ({ tabs = [], active, onChange }) => (
  <MDBox
    sx={{
      display: "flex",
      borderBottom: ({ palette }) => `1px solid ${palette.grey[300]}`,
      mb: 3,
      overflowX: "auto",
      overflowY: "hidden",
      "&::-webkit-scrollbar": { display: "none" },
      scrollbarWidth: "none",
    }}
  >
    {tabs.map((t) => {
      const isActive = t.key === active
      return (
        <MDBox
          key={t.key}
          component="button"
          type="button"
          onClick={() => onChange(t.key)}
          sx={{
            appearance: "none",
            background: "none",
            border: "none",
            borderBottom: "2px solid",
            borderColor: isActive ? "info.main" : "transparent",
            marginBottom: "-1px",
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
            px: 2,
            py: 1.25,
            transition: "border-color .15s ease",
          }}
        >
          <MDTypography
            variant="button"
            fontWeight={isActive ? "bold" : "regular"}
            color={isActive ? "info" : "text"}
            sx={{
              fontSize: "0.8125rem",
              opacity: isActive ? 1 : 0.85,
              "&:hover": { opacity: 1 },
            }}
          >
            {t.label}
          </MDTypography>
        </MDBox>
      )
    })}
  </MDBox>
)

export default ReportTabs
